var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticleArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.935,
    height: 23.935,
    viewBox: "0 0 23.935 23.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_987",
    "data-name": "Rectangle 987",
    width: 23.935,
    height: 23.935,
    fill: "#106da0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831",
    transform: "translate(23.935 23.935) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8092",
    "data-name": "Path 8092",
    d: "M11.968,0A11.968,11.968,0,1,0,23.935,11.968,11.981,11.981,0,0,0,11.968,0Zm0,22.385A10.418,10.418,0,1,1,22.385,11.968,10.43,10.43,0,0,1,11.968,22.385m5.811-11.9H9.914L13,7.394a1.292,1.292,0,0,0,0-1.827l-.251-.25a1.291,1.291,0,0,0-1.826,0L5.243,11a1.291,1.291,0,0,0-.378.913v.111a1.292,1.292,0,0,0,.378.913l5.682,5.682a1.291,1.291,0,0,0,1.826,0l.251-.25a1.292,1.292,0,0,0,0-1.826L9.914,13.454h7.864a1.291,1.291,0,0,0,1.291-1.291v-.39A1.291,1.291,0,0,0,17.779,10.481Z",
    fill: "#106da0",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleArrow);
export default __webpack_public_path__ + "static/media/article-arrow.697058a1ec0dc7fd9ce6a30b429fbb98.svg";
export { ForwardRef as ReactComponent };